import {singleton} from "tsyringe";
import {TimelineConfiguration} from "../timeline/timeline-configuration.interface";

@singleton()
export class TimelineConfigurationManager {

    private _timelineConfigurations = new Map<string, TimelineConfiguration[]>();

    public register(key: string, configurations: TimelineConfiguration[]): void {
        this._timelineConfigurations.set(key, configurations);
    }

    public get(viewName: string): TimelineConfiguration[] {
        return this._timelineConfigurations.get(viewName) ?? [];
    }
}